export default {
  getMovieId: function (url: string): string {
    const match = url.match(/https:\/\/youtu\.be\/(.+)/)

    if (!match) {
      return ''
    }

    return match[1]
  },
  getThumbnailLink: function (movieId: string): string {
    return 'https://img.youtube.com/vi/' + movieId + '/mqdefault.jpg'
  },
  getEmbedCode: function (url: string): string {
    return (
      '<div class="smaller-video-box"><div class="video-container"><iframe class="video" src="https://www.youtube.com/embed/' +
      this.getMovieId(url) +
      '" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div></div>'
    )
  },
}
